export default __webpack_public_path__ + "static/earo-bg-4e7cbf9873229f5e25902da47aa4f90f.png";